/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Users module

define('modules/User/Users.Forms',[], function () {
    'use strict';

    // Forms definitions
    var forms = {
        'Login': {
            Fields: [
                { 'Name': 'Email', 'Field': '#login_email', 'Param': 'username', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] },
                { 'Name': 'Password', 'Field': '#login_password', 'Param': 'password', 'Type': 'Text' },
                { 'Name': 'KeepLoggednIn', 'Field': '#login_keep', 'Param': 'keepLoggedIn', 'Type': 'Checkbox', 'Optional': true }
            ],
            Validate: true
        },
        'Email': {
            Fields: [
                { 'Name': 'Email', 'Field': '#register_email', 'Param': 'email', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] },
                {
                    'Name': 'Confirm Email', 'Field': '#register_email2', 'Param': 'emailConfirm', 'Type': 'Text',
                    'Validators':
                        [
                            { 'Type': 'Email' },
                            {
                                'Type': 'ConfirmField',
                                'OriginField': '#register_email',
                                'ErrorMsg': 'Email does not match the confirm email.'
                            }]
                }
            ],
            Validate: true
        },
        'Registration': {
            Fields: [
                {
                    'Name': 'First Name',
                    'Field': '#register_first_name',
                    'Param': 'firstName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Last Name',
                    'Field': '#register_last_name',
                    'Param': 'lastName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Email',
                    'Field': '#register_email',
                    'Param': 'email',
                    'Type': 'Text',
                    'Validators': [{
                        'Type': 'Email'
                    }]
                },
                {
                    'Name': 'Confirm Email',
                    'Field': '#register_email2',
                    'Param': 'emailConfirm',
                    'Type': 'Text',
                    'Validators':
                        [
                            { 'Type': 'Email' },
                            {
                                'Type': 'ConfirmField',
                                'OriginField': '#register_email',
                                'ErrorMsg': 'Email does not match the confirm email.'
                            }]
                },
                {
                    'Name': 'Password',
                    'Field': '#register_password',
                    'Param': 'password',
                    'Type': 'Text'
                },
                {
                    'Name': 'Confirm Password',
                    'Field': '#register_password2',
                    'Param': 'passwordConfirm',
                    'Type': 'Text',
                    'Validators':
                        [
                            {
                                'Type': 'ConfirmField',
                                'OriginField': '#register_password',
                                'ErrorMsg': 'Password does not match the confirm password.'
                            }]
                },
                {
                    'Name': 'Organization name',
                    'Field': '#register_organization',
                    'Param': 'organizationName',
                    'Type': 'Text',
                    'Optional': true,
                    'Validators':
                        [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#requestBusinessAccount',
                                'ConditionalValue': true,
                                'ConditionalFieldType': 'Checkbox'
                            }]
                },
                {
                    'Name': 'emailSignUp',
                    'Field': '#requestEmailSignUp',
                    'Param': 'emailSignUp',
                    'Type': 'Checkbox',
                    'Optional': true
                },
            ],
            Validate: true
        },
        'ForgotPassword': {
            Fields: [
                { 'Name': 'Email', 'Field': '#forgot_email', 'Param': 'email', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] }
            ],
            Validate: true
        },
        'ChangePassword': {
            Fields: [
                { 'Name': 'User id', 'Field': '#forgot_user_id', 'Param': 'userId', 'Type': 'Hidden' },
                { 'Name': 'Password', 'Field': '#forgot_password', 'Param': 'newPassword', 'Type': 'Text' },
                { 'Name': 'Confirm Password', 'Field': '#forgot_password2', 'Type': 'Text' }
            ],
            Validate: true
        },
        'EditAccount': {
            Fields: [
                { 'Name': 'Password', 'Field': '#current-password', 'Param': 'currentPassword', 'Type': 'Text' },
                { 'Name': 'New Password', 'Field': '#new-password', 'Param': 'newPassword', 'Type': 'Text' },
                { 'Name': 'Retype New Password', 'Field': '#new-password-confirm', 'Type': 'Text' }
            ],
            Validate: true
        },
        'EditProfile': {
            Fields: [
                { 'Name': 'First Name', 'Field': '#first-name', 'Param': 'firstName', 'Type': 'Text' },
                { 'Name': 'Last Name', 'Field': '#last-name', 'Param': 'lastName', 'Type': 'Text' }
            ],
            Validate: true
        },
    };

    return forms;
});
